import { Component, inject } from '@angular/core';
import { AssociationAreaService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  AssociationAreaCreateDto,
  AssociationAreaDto,
  AssociationAreaExcelDownloadDto,
  AssociationAreaUpdateDto,
} from '../proxy/controlling/dtos/association-area';
import { ASSOCIATIONAREA_CONFIG, ASSOCIATIONAREA_FIELDS } from './association-area.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-association-area',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, AssociationAreaService, ConfirmationService],
  templateUrl: './association-area.html',
  styleUrl: './association-area.scss',
})
export class AssociationArea extends BaseCrudComponent<
  AssociationAreaDto,
  AssociationAreaCreateDto,
  AssociationAreaUpdateDto,
  AssociationAreaExcelDownloadDto
> {
  service = inject(AssociationAreaService);
  config = ASSOCIATIONAREA_CONFIG;
  fields = ASSOCIATIONAREA_FIELDS;

  protected prepareUpdateDto(data: any, selected: AssociationAreaDto): AssociationAreaUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'AssociationArea';
  }
}
